<template>
<div>
  <v-app-bar app clipped-left color='primary' dark :flat='$route.path === "/"' disable-resize-watcher>
    <v-toolbar-title class='headline text-uppercase'>
      <!-- <v-app-bar-nav-icon @click='onDrawer' class='hidden-lg-and-up' /> -->
      <span v-if='!isSankey'>Regenerative Building Portal</span>
      <span v-else>Regenerative Building Simulator</span>
      <span class='ml-2 title font-weight-light'>by ASDL</span>
    </v-toolbar-title>
    <v-spacer />

    <v-toolbar-items class='hidden-md-and-down'>
      <template v-for='(x, i) in menuItems'>
        <v-tooltip bottom color='primary'>
          <template #activator='{ on }'>
            <v-btn text primary v-on='on' :to='x.to' @click='ifKendeda(i)'>
              {{ x.title }}
            </v-btn>
          </template>
          <span>{{ x.tooltip }}</span>
        </v-tooltip>
      </template>
    </v-toolbar-items>
  </v-app-bar>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
  }),
  computed: {
    ...mapState(['menuItems']),
    isSankey() {
      return this.$route.path === '/rbs'
    }
  },
  methods: {
    onDrawer() {
      this.$root.$emit('onDrawer')
    },
    ifKendeda(i) {
      console.log(i)
      if (i==4){
          return window.open('https://livingbuilding.gatech.edu/')
      }
    }
  }
}
</script>

<style lang='stylus'>
</style>
